import React, { useState } from 'react';
import classNames from 'classnames';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';

import { Icon } from 'js/components';

/**
 * Icon + label dropdown used by question type, decoration, and similar
 * editor menus. The toggle is a two-column grid (content | caret) so the
 * caret stays on the same line as the label.
 */
export function ActionSelector({
  value,
  options = [],
  onChange = () => {},
  className,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selected = options.find((option) => option.key === value) ?? options[0];

  if (!selected) {
    return null;
  }

  return (
    <Dropdown
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
      className={classNames('action-selector', className)}
    >
      <DropdownToggle caret>
        <div>
          {selected.icon ? (
            <Icon icon={selected.icon} className="btn-icon-left" />
          ) : null}
          {selected.icon ? ' ' : null}
          {selected.name}
        </div>
      </DropdownToggle>
      <DropdownMenu>
        {options.map(({ key, name, icon }) => (
          <DropdownItem key={key} onClick={() => onChange(key)}>
            {icon ? <Icon icon={icon} className="btn-icon-left" /> : null}
            {icon ? ' ' : null}
            {name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default ActionSelector;
